import { BookmakerApprovalIcon } from "../icons";
import List from "./List";

export default {
	icon: BookmakerApprovalIcon,
	list: List,
	options: {
		group: "bookmakers",
		roles: ["admin", "affiliate_manager"],
	},
};
